<template>
    <div class="admin-archive">
        <form :action="activateFormAction" method="POST">
            <input type="hidden" name="_token" :value="csrfToken">
            <button
                class="button button-primary admin-archive-button"
                :disabled="popupOpen"
                v-if="isArchived"
            >
                <i class="icon icon-check-circle"></i>

                Activate
            </button>
            <input type="hidden" name="prev-url" :value="httpReferer">
            <div class="cl"></div>
        </form>

        <form :action="archiveFormAction" method="POST">
            <input type="hidden" name="prev-url" :value="httpReferer">
            <input type="hidden" name="_token" :value="csrfToken">
            <button
                class="button button-primary admin-archive-button"
                @click="archive"
                type="submit"
                name="follow-up"
                value="next-reminder"
                :disabled="popupOpen"
                v-if="!isArchived"
            >
                <i class="icon icon-archive"></i>

                Archive
            </button>
            <div class="popup-holder" v-if="popupOpen">
                <div class="cl"></div>

                <div class="popup admin-archive-popup" >
                    <div class="popup__content">
                        <i class="icon icon-x right" @click="popupOpen = false"></i>
                        <h4>Follow Up</h4>
                        <p>Please choose appropriate time to follow up. </p>
                        <div class="cl"></div>
                        <button ref="nextBusinessDayButton" class="button button-small bolded" title="Send the project to the &quot;In Progress&quot; list and schedule a follow up for next business day, at 9 AM" type="submit" name="follow-up" value="next-business-day">
                            <template v-if="isMondayNextBusinessDay">
                                M<u>o</u>nday
                            </template>
                            <template v-else>
                                T<u>o</u>morrow
                            </template>
                        </button>
                        <button ref="nextWeekButton" class="button button-small bolded" type="submit" name="follow-up" value="next-week" title="Send the project to &quot;In Progress&quot; list and schedule a follow up in 7 days(at 9 AM)">In a <u>W</u>eek</button>
                        <button ref="somedayButton" class="button button-small bolded" type="submit" name="follow-up" value="someday" title="Send the project to the &quot;In Progress&quot; list and do not schedule a follow up date"><u>S</u>omeday</button>
                        <button  class="button button-small bolded" type="submit" name="follow-up" value="never" title="Send the project to &quot;Archived&quot; list">Never</button>
                        <i class="icon icon-help-circle right archive-help-ctrl" @click="helpOpen = !helpOpen"></i>
                        <div class="cl"></div>
                        <div class="specific-date">
                            <div>
                            Or choose date and time:
                                <component
                                    v-if="flatPickr"
                                    :is="flatPickr"
                                    v-model="date"
                                    name="date"
                                    class="field field-large"
                                    :config="flatPickrConfig"
                                ></component>
                            </div>
                            <div>
                                <button class="button bolded left" name="follow-up" value="specific-date" title="Send the project to &quot;In Progress&quot; list and setup specific date and time for a follow up">OK</button>
                            </div>
                        </div>
                        <div class="cl"></div>
                        <div class="archive-help" v-if="helpOpen">
                            <p>You're the main manager in this project, so it's up to you to move forward the communication from our side. You should follow up on this project if the client doesn't reply. </p>

                            <p>Choosing appropriate date and time for a follow up here will send the project to "In Progress" list of projects. </p>
                            <ul>
                                <li><strong>T<u>o</u>morrow / M<u>o</u>nday</strong>(Shortcut: <kbd>o</kbd>): the project will be scheduled for a follow up tomorrow morning(or on Monday if today is Friday) at 9AM. </li>
                                <li><strong>In a <u>W</u>eek</strong>(Shortcut: <kbd>w</kbd>): the project will be scheduled for a follow up in 7 days, at 9AM</li>
                                <li><strong><u>S</u>omeday</strong>(Shortcut: <kbd>s</kbd>): This will put the project in your <em>In Progress</em> list, but it will be always at the bottom. </li>
                                <li><strong>Never</strong>: Choose this if the project is complete, and you don't have to follow up further</li>
                            </ul>

                            <p>You can use the combination <kbd>a</kbd>, then <kbd>w</kbd>, <kbd>s</kbd>, or <kbd>о</kbd> to quickly send a project to the <em>In Progress</em> List. </p>
                            <p><em>NB: If you already have a reminder, you'll avoid this dialog altogether.</em></p>
                        </div>
                    </div>

                </div>
            </div>

        </form>
    </div>
</template>
<style>
    .admin-archive {
        float: left;
    }

    .flatpickr-calendar.open {
        z-index: 100001;
    }

    .specific-date {
        padding-top: 10px;
        margin-top: 10px;
        border-top: solid 1px var(--color-gray-600);
    }

    .specific-date button {
        margin-top: 8px;
    }
</style>
<script>
    import { markRaw } from 'vue';

    let flatPickrLib;

    export default {
        data() {

            const today = new Date();
            const nextBusinessDay = new Date();
            nextBusinessDay.setHours(9);
            nextBusinessDay.setMinutes(0);
            if ( today.getDay() === 5 ) { // friday
                nextBusinessDay.setDate(nextBusinessDay.getDate() + 3);
            } else if ( today.getDay() === 6 ) { // Saturday
                nextBusinessDay.setDate(nextBusinessDay.getDate() + 2);
            } else {
                nextBusinessDay.setDate(nextBusinessDay.getDate() + 1);
            }

            return {
                csrfToken: document.querySelector('head meta[name="csrf-token"]')?.content,
                excludeStatus: ['after_sale', 'lost', 'spam'],
                isArchived: $$projectIsArchived,
                popupOpen: false,
                isMondayNextBusinessDay: false,
                helpOpen: false,
                date: null,
                httpReferer: $$httpReferer,
                archiveFormAction: this.getBaseUri() + '/archive-project',
                activateFormAction: this.getBaseUri() + '/activate',
                flatPickr: null,
                flatPickrLib: null,
                flatPickrConfig: {
                    enableTime: true,
                    altInput: true,
                    altFormat: "D, d M \\a\\t H:i",
                    dateFormat: "Y-m-d H:i:s",
                    // minDate: new Date(),
                    time_24hr: true,
                    defaultDate: $$activateAtDate && !/^9999-12-31/.test($$activateAtDate) ? $$activateAtDate : nextBusinessDay,
                    firstDayOfWeek: 1,
                }
            }
        },

        mounted() {
            const currentWeekdayIndex = (new Date()).getDay();
            this.isMondayNextBusinessDay = [5, 6, 0].includes(currentWeekdayIndex);

            const vm = this;

            window.addEventListener('keyup', function (e) {
                // Don't fire in text-accepting inputs that we didn't directly bind to
                if ( this !== e.target && (/textarea|select/i.test( e.target.nodeName ) ||
                     e.target.type === "text") ) {
                    return;
                }

                if (!vm.popupOpen) {
                    return;
                }

                if ( e.which === 27 ) {
                    vm.popupOpen = false;
                } else if ( e.which === 79 ) {
                    // "o" has been clicked
                    vm.$refs.nextBusinessDayButton.click();
                } else if ( e.which === 87 ) {
                    // "w" has been clicked
                    vm.$refs.nextWeekButton.click();
                } else if ( e.which === 83) {
                    // "s" has been clicked
                    vm.$refs.somedayButton.click();
                }
            });
            const editFollowUpLink = document.querySelector('.edit-follow-up');
            if (editFollowUpLink) {
                editFollowUpLink.addEventListener('click', e => {
                    e.preventDefault();
                    this.popupOpen = true;
                })
            }
        },

        methods: {
            getBaseUri() {
                return window.location.toString().replace(/[#?].*/, '');
            },
            archive(e) {
                const projectStatus = document.getElementById('new_status')?.value;
                // Rely on jQuery for fetching the last reminders since that module is not migrated to vue yet
                const hasActiveReminders = $('.project-reminder').not('.project-reminder-is-past').length > 0;
                if (hasActiveReminders || this.excludeStatus.includes(projectStatus)) {
                    return;
                }
                e.preventDefault();

                this.popupOpen = true;
            },
            loadComponent() {
                Promise.all([
                    import('vue-flatpickr-component'),
                    import('flatpickr'),
                    import('flatpickr/dist/flatpickr.css'),
                    import('flatpickr/dist/themes/airbnb.css'),
                ]).then(([flatPickr, lib ]) => {
                    flatPickrLib = lib.default;
                    flatPickrLib.l10ns.default.firstDayOfWeek = 1;
                    this.flatPickr = markRaw(flatPickr.default)
                });
            },
            activate() {

            }
        },
        created() {
            this.loadComponent();
        },
    }
</script>
